import Axios from "@/plugins/axios";

class DashboardApi {
    getDashboardContent(userId) {
        return Axios.get('api/dashboard/' + userId);
    }
}

export default new DashboardApi();
